import React, { useContext } from 'react';
import { ComponentContext } from '../../contexts';
import { GenericIcon } from '../../generic/icon/generic-icon';
import { COLORS } from '../../constants';
export var Icon = function (_a) {
    var definition = _a.definition;
    var width = definition.width, height = definition.height;
    var PointerArea = useContext(ComponentContext).PointerArea;
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericIcon, { size: width, type: definition.icon, fill: COLORS.SECONDARY_SHAPE_STROKE }),
        React.createElement(PointerArea, { width: width, height: height })));
};
//# sourceMappingURL=icon.js.map